import React from 'react';
import PropTypes from 'prop-types';
import {
  findCurrencySymbol,
  formatPrice,
  handleShippingAddressInOrder,
} from '../../../../services/utilityFunctions';
import FormattedAddress from '../../../shop/FormattedAddress';
import translate from '../../../../commonComponents/translate';
import shippingProviderProp from '../../../shop/propTypes/shippingProviderProp';
import CurrencyProp from '../../../profile/propTypes/currencyProp';
import UserProp from '../../../../commonComponents/propTypes/userProp';
import PenEditButton from '../../../../commonComponents/buttons/PenEditButton';

const INDIVIDUAL_PROFILE = 'individual';

function DisplayShippingItem(props) {
  const {
    t,
    shipping,
    index,
    user,
    shippingCountry,
    currencies,
    isProvider,
    selectedShipping,
    onSelectShipping,
    isShippingAddress,
    includesBilling,
    onAddressOpen,
  } = props;

  let isValidShippingAddress;

  // Check if it's shipping address
  if (isShippingAddress) {
    // check if is "individual" if it is, check if has shipping country
    if (
      !user?.personalInfo?.businessType ||
      user?.personalInfo?.businessType === INDIVIDUAL_PROFILE
    ) {
      isValidShippingAddress = !(
        shippingCountry && shippingCountry !== shipping.countryCode
      );
    } else {
      isValidShippingAddress = true;
    }
  }

  // Checked shipping radio button
  const selectedShippingId = selectedShipping ? selectedShipping._id : null;

  const providerName = `${t('shipping_providers')} ${index + 1}`;
  const isBilling = includesBilling && index === 0;
  const addressName = isBilling
    ? t('billing_address')
    : `${t('shipping_address')} ${includesBilling ? index : index + 1}`;

  return (
    <>
      <div
        className={`shipping-item ${
          isShippingAddress && !isValidShippingAddress
            ? 'disabled-shipping'
            : ''
        }`}
        onClick={() => {
          onSelectShipping(shipping);
        }}
      >
        {!isProvider ? (
          <PenEditButton
            onClick={() => onAddressOpen('shipping', shipping, index)}
          />
        ) : null}
        <div className="col-lg-1 col-12 shipping-radio">
          <input
            type="radio"
            onChange={() => {}}
            checked={selectedShippingId === shipping._id}
          />
        </div>
        <span className="col-lg-11 col-12 row">
          <h6 className="col-lg-12">
            <span className="shipping-title">
              {isProvider ? providerName : addressName}
            </span>
          </h6>
          <span className="col-lg-12 shipping-content">
            {isProvider ? (
              <p>
                <span>
                  <strong>
                    {`${shipping.name} - ${formatPrice(
                      shipping.userPrice !== null
                        ? Math.round(shipping?.userPrice?.price)
                        : Math.round(shipping?.userClickAndCollectPrice?.price),
                      findCurrencySymbol(
                        shipping?.userPrice?.code ||
                          shipping?.userClickAndCollectPrice?.code,
                        currencies,
                      ),
                    )}`}
                  </strong>
                  <br />
                  {`(${t('order_without_tax')})`}
                </span>
              </p>
            ) : (
              <span className="row">
                <span className="col-12 order-create-address-container">
                  <FormattedAddress
                    address={handleShippingAddressInOrder(user, shipping)}
                    showOptionalFields
                  />
                </span>
                {!isValidShippingAddress && (
                  <span className="col-12 warning-message">
                    {t(
                      'order.create.errorMessage.addressDifferentFromShippingCountry',
                    )}
                  </span>
                )}
              </span>
            )}
          </span>
        </span>
      </div>
    </>
  );
}

DisplayShippingItem.propTypes = {
  t: PropTypes.func.isRequired,
  shipping: PropTypes.shape(shippingProviderProp.propType).isRequired,
  selectedShipping: PropTypes.shape(shippingProviderProp.propType),
  onSelectShipping: PropTypes.func.isRequired,
  isProvider: PropTypes.bool,
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType)),
  user: PropTypes.shape(UserProp.propType),
  shippingCountry: PropTypes.string,
  index: PropTypes.number.isRequired,
  isShippingAddress: PropTypes.bool,
  includesBilling: PropTypes.bool,
  onAddressOpen: PropTypes.func,
};

DisplayShippingItem.defaultProps = {
  isProvider: false,
  currencies: [],
  shippingCountry: null,
  user: null,
  selectedShipping: null,
  isShippingAddress: false,
  includesBilling: false,
  onAddressOpen: null,
};

export default translate(DisplayShippingItem);
